import { useMutation, useQueryClient } from "@tanstack/react-query";
import axiosInstance from "../../../../config/apiConfig";

const updateBlog = async ({ id, blogData }) => {
  try {
    const payload = { ...blogData, id };
    const { data } = await axiosInstance.put(`/Blog/${id}`, payload);
    return data;
  } catch (error) {
    console.error("Error updating blog:", error);
    throw error;
  }
};

const useUpdateBlog = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateBlog,
    onSuccess: () => {
      queryClient.invalidateQueries(["blogs"]);
    },
    onError: (err) => {
      console.error("Update blog mutation failed:", err);
    },
  });
};

export default useUpdateBlog;

